import React, { useState } from 'react';
import trans from 'translate';
import PropTypes from 'prop-types';

import './YellowAlert.scss';
import ShowAt from '../ShowAt/ShowAt';

const YellowAlert = ({ text, dismissFunc }) => {
  const [showed, setShowed] = useState(true);

  const hide = () => setShowed(false);

  return (
    <ShowAt at={showed}>
      <div className="yellow-alert-wrapper">
        <div className="text">{text}</div>
        <div onClick={dismissFunc || hide} className="button dismiss">
          {trans('common.dismiss')}
        </div>
      </div>
    </ShowAt>
  );
};

YellowAlert.defaultProps = {
  dismissFunc: null,
};

YellowAlert.propTypes = {
  text: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]).isRequired,
  dismissFunc: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default YellowAlert;
